export interface FileUploadRes {
  success: boolean
  data: {
    id: `${string}-${string}-${string}-${string}-${string}`
    filename: string
    size: number
    url: string
    created_at: number
  }
}

export function getAssetsPath(fileId: string) {
  return `assets/${fileId}`
}
